export const url = "https://mybesttrip-backend-gla9p.ondigitalocean.app/";
